import config from 'config';

const trimSlashes = (value = '') => value.replace(/^\/+|\/+$/g, '');

export const AGENT_CONVERSATIONS_PATH = '/api/agent/conversations';
export const AGENT_CONVERSATION_STOP_PATH = `${AGENT_CONVERSATIONS_PATH}/stop`;

export const getAgentUrl = (path = '') => {
  const baseUrl = config.agent?.baseUrl || config.api.baseUrl;
  const cleanBase = trimSlashes(baseUrl || '');
  const cleanPath = trimSlashes(path);

  return `${cleanBase ? `${cleanBase}/` : '/'}${cleanPath}`;
};

const parseError = async (response) => {
  try {
    const data = await response.json();
    return data.message || data.error || response.statusText;
  } catch (err) {
    return response.statusText;
  }
};

export const agentFetch = async (path, token, opts = {}) => {
  const response = await fetch(getAgentUrl(path), {
    ...opts,
    credentials: opts.credentials || 'omit',
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
      ...(opts.headers || {}),
    },
  });

  if (!response.ok) {
    throw new Error(await parseError(response));
  }

  if (response.status === 204) {
    return {};
  }

  const text = await response.text();
  return text ? JSON.parse(text) : {};
};

export const listAgentConversations = (token) => agentFetch(AGENT_CONVERSATIONS_PATH, token);

export const getAgentConversation = (token, conversationId) => agentFetch(`${AGENT_CONVERSATIONS_PATH}/${conversationId}`, token);

export const renameAgentConversation = (token, conversationId, title) =>
  agentFetch(`${AGENT_CONVERSATIONS_PATH}/${conversationId}`, token, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ title }),
  });

export const deleteAgentConversation = (token, conversationId) =>
  agentFetch(`${AGENT_CONVERSATIONS_PATH}/${conversationId}`, token, {
    method: 'DELETE',
  });

export const stopAgentConversation = (token, { streamId, conversationId } = {}) =>
  agentFetch(AGENT_CONVERSATION_STOP_PATH, token, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      stream_id: streamId,
      conversation_id: conversationId || null,
    }),
  });

export const deleteAgentConversations = async (token, conversationIds = []) => {
  const results = await Promise.allSettled(conversationIds.map((conversationId) => deleteAgentConversation(token, conversationId)));
  const deletedIds = conversationIds.filter((_, index) => results[index].status === 'fulfilled');
  const failed = results
    .map((result, index) => ({ result, id: conversationIds[index] }))
    .filter(({ result }) => result.status === 'rejected')
    .map(({ result, id }) => ({ id, error: result.reason }));

  return {
    deletedIds,
    failed,
    hasFailures: failed.length > 0,
  };
};
